import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  title: {
    padding: '55px 0 70px',
    [theme.breakpoints.up(768)]: {
      padding: '40px 0 50px',
    },
  },
});
